import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import { createBrowserRouter, redirect, RouterProvider } from 'react-router-dom';
import AdminPage from './pages/admin/Admin';
import ApplicationsPage from './pages/admin/Applications';
import LicensesPage from './pages/admin/Licenses';
import ProfilePage from './pages/admin/Profile';
import UsersPage from './pages/admin/Users';
import ContatoPage from './pages/ContatoPage';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RootLayout from './pages/Root';
import ServicosPage from './pages/ServicosPage';
import PortfolioPage from './pages/PortfolioPage';

function App() {

  const isTokenValid = () => {
    const token = localStorage.getItem("token");
    if (!token) return false;

    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.exp > Date.now() / 1000;
    } catch {
      return false;
    }
  }

  // 🔐 Salva apenas o token
  const loginHandler = (data) => {
    try {
      localStorage.setItem('token', data.token);
      Object.keys(data).forEach((key) => {
        localStorage.setItem(key, data[key]);
      });
      window.location.href = "/admin";
    } catch (error) {
      console.warn(error);
    }
  };

  const logoutHandler = () => {
    localStorage.removeItem('token');
    localStorage.clear();
    window.location.href = "/login";
  };

  // 🔎 Verifica token e expiração
  const checkAuthLoader = () => {
    const token = localStorage.getItem("token");

    if (!token) {
      return redirect('/login');
    }

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));

      const now = Date.now() / 1000;

      if (payload.exp < now) {
        localStorage.removeItem("token");
        return redirect('/login');
      }

      return null;

    } catch (error) {
      localStorage.removeItem("token");
      return redirect('/login');
    }
  };

  const router = createBrowserRouter([
    {
      path: '/',
      element: <RootLayout isLoggedIn={isTokenValid()} onLogout={logoutHandler} />,
      children: [
        { path: '/', element: <HomePage /> },
        { path: '/login', element: <LoginPage onLogin={loginHandler} /> },
        { path: '/servicos', element: <ServicosPage /> },
        { path: '/portfolio', element: <PortfolioPage /> },
        { path: '/contato', element: <ContatoPage /> },                
        { path: '/admin', element: <AdminPage />, loader: checkAuthLoader },
        { path: '/admin/perfil', element: <ProfilePage />, loader: checkAuthLoader },
        { path: '/admin/aplicativos', element: <ApplicationsPage />, loader: checkAuthLoader },
        { path: '/admin/usuarios', element: <UsersPage />, loader: checkAuthLoader },
        { path: '/admin/licencas', element: <LicensesPage />, loader: checkAuthLoader }
      ]
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;